import React, {Component} from "react";
import {
	Box,
	Button,
	Backdrop,
	Container,
	CircularProgress
} from "@mui/material";
import {
	UsdtTrc20,
	HeadElement,
	FormSection,
	AliPayContent,
	PayInfoSelect,
	DefaultAmounts,
	PaymentConverter
} from "./components";
import {
	notification,
	notificationTypes
} from "../../../utils/notification";
import {
	VisibleContent
} from "../../../components";
import getTrans from "../../../languages/getTrans";
import agent from "../../../agent/agent";

class TopUpBalanceSlugPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			paymentDetail: null,
			paymentOptions: [],
			amount: "",
			isBackdrop: false,

			isAliPay: false,
			isUsdtTrc20: false,
		};
		this.refPaymentLink = React.createRef();
	}

	componentDidMount = async () => {
		await this.initSelectedPayment();
	}
	initSelectedPayment = async () => {
		const {
			itemId,
			groupSlug,
			countrySlug
		} = this.props?.match?.params || {};

		const paymentDetail = await agent.get(`/api/payflow/countries/${ countrySlug }/groups/${ groupSlug }`)
			.then((res) => (res.data || []).find((t) => Boolean(String(itemId) === String(t.paymentMethodId)))).catch(() => null);
		if (!paymentDetail) {
			notification({
				type: notificationTypes.error,
				message: getTrans('balance.Платежная система не найден')
			})
			this.props.history.replace('/top-up-balance');
			return
		}
		if (String(paymentDetail?.paymentMethodId) === "47") {
			await this.setState({paymentDetail, isAliPay: true})
			return
		}
		if (String(paymentDetail?.paymentMethodId) === "49") {
			await this.setState({paymentDetail, isUsdtTrc20: true})
			return
		}

		const paymentOptions = this.getPaymentMethodOptions(paymentDetail);
		this.setState({
			paymentDetail,
			paymentOptions,
			amount: paymentDetail?.minValue || ""
		})
	}
	getPaymentMethodOptions = (selectedPay) => {
		const paymentMethodOptionsTypes = selectedPay?.paymentMethodOptionsTypes || {};
		const paymentMethodOptionsLabels = selectedPay?.paymentMethodOptionsLabels || {};
		if (Object.keys(paymentMethodOptionsTypes).length <= 0) {
			return []
		}

		const langCode = this.props?.locale || "en";

		let paymentMethodOptions = [];
		Object.keys(paymentMethodOptionsTypes).map((key) => {
			const label = paymentMethodOptionsLabels[key] || "";
			let caption = "";
			let placeholder = "";
			if (key === "phone") {
				let phoneMaskCode = "";
				switch (langCode) {
					case "ru": {
						phoneMaskCode = "+7 912 345-67-89"
						break
					}
					case "cn": {
						phoneMaskCode = "+86 138 1234 5678"
						break
					}
					case "tr": {
						phoneMaskCode = "+90 555 123 45 67"
						break
					}
					case "es": {
						phoneMaskCode = "+34 612 34 56 78"
						break
					}
					case "hi": {
						phoneMaskCode = "+91 98765 43210"
						break
					}
					case "ar": {
						phoneMaskCode = "+20 123 456 7890"
						break
					}
					default: {
						phoneMaskCode = "+1 555 123 4567"
						break
					}
				}

				caption = getTrans('forms.Введите номер в международном формате, например {{phoneNumber}}', {
					phoneNumber: phoneMaskCode
				});
				placeholder = phoneMaskCode;
			}

			let _value = "";
			if (key === "email") {
				const user = this.props?.user;
				_value = user?.settings?.email || user?.email || "";
				if (_value.includes('bot@grizzlysms.com')) {
					_value = '';
				}
			}

			paymentMethodOptions.push({
				key, label,
				value: _value || "",
				caption: caption || "",
				placeholder: placeholder || ""
			})
		});

		return paymentMethodOptions
	}

	changeAmount = async (amount) => {
		const newAmount = typeof amount === 'object' && amount !== null && 'newAmount' in amount ? amount.newAmount : amount;
		this.setState({ amount: newAmount });
	}
	changePaymentOptions = () => {}

	createLinkPayment = async () => {
		const {amount} = this.state;
		await this.setState({
			isBackdrop: true,
			paymentLink: "",
		});
		const { paymentDetail, paymentOptions } = this.state;
		console.log('paymentDetail: ', paymentDetail)

		if (paymentOptions.length > 0 && paymentOptions.find((t) => !t.value)) {
			this.setState({ isBackdrop: false });
			let _message = paymentOptions.filter((t) => !t.value).map(t => `${t.label} - ${getTrans('forms.Обязательно к заполнению')}`).join(";<br/>");
			notification({
				message: _message,
				type: notificationTypes.error,
			})
			return
		}

		const body = {
			"options": {},
			"service_id": 1,
			"amount": amount,
			"payment_method_id": paymentDetail?.paymentMethodId,
			"successUrl": `https://t.me/GrizzlySMScom_bot/play?startapp=payments`
		};
		if (paymentDetail?.paymentMethodType && paymentDetail?.paymentMethodTypeAttribute) {
			body.options[paymentDetail.paymentMethodTypeAttribute] = paymentDetail.paymentMethodType;
		}
		if (paymentOptions.length > 0) {
			paymentOptions.map(t => {
				body.options[t.key] = t?.value;
			})
		}

		let queryParams = [];
		queryParams.push(`config=grizzlysms.com`);

		const res = await agent.post(`/api/payment-intents?${ queryParams.join('&') }`, body).then((res) => {
			return res.data
		}).catch((err) => {
			const data = err?.response?.data;
			let errMessage = "";
			if (data?.[0]?.message) {
				errMessage = data?.[0]?.message;
			}
			return {error: errMessage || getTrans('errors.Ошибка сервера')}
		});
		if (res?.error) {
			await this.setState({ isBackdrop: false });
			notification({
				message: res?.error,
				type: notificationTypes.error
			})
			return
		}

		await this.setState({
			isBackdrop: false,
			paymentLink: res?.pay_url,
		});

		const paymentLink = res?.pay_url;
		try {
			window.Telegram.WebApp.openLink(paymentLink);
		} catch (err) {
			window.location.href = paymentLink;
		}
	}

	render() {
		const {
			amount,
			isBackdrop,
			paymentDetail,
			paymentOptions,

			isAliPay,
			isUsdtTrc20
		} = this.state;

		if (!paymentDetail) {
			return (
				<></>
			)
		}
		return (
			<Container>
				<HeadElement iconId={paymentDetail?.image_id} name={paymentDetail?.paymentMethodName} />
				<Container sx={{height: "calc(100vh - 140px)", overflow: "auto", padding: "0", marginBottom: "-78px", paddingBottom: "78px", width: "auto", marginRight: "-10px", paddingRight: "10px"}}>
					<VisibleContent visible={!isAliPay && !isUsdtTrc20}>
						<PayInfoSelect item={paymentDetail} amount={amount}/>
						<DefaultAmounts items={paymentDetail.buttonsPaymentsAmount} minValue={paymentDetail?.minValue} active={amount} onChange={this.changeAmount}/>
						<PaymentConverter paymentAmount={amount} onChangeAmount={this.changeAmount} servicePayInfo={paymentDetail}/>
						<VisibleContent visible={paymentOptions.length > 0}>
							<FormSection values={paymentOptions} onChange={this.changePaymentOptions}/>
						</VisibleContent>
						<Box mt={2}/>
						<Button
							fullWidth
							variant="contained"
							sx={{height: 42, borderRadius: "8px", fontSize: 18}}
							onClick={this.createLinkPayment}
						>{getTrans('topUpBalanceSlug.Пополнить')}</Button>
				</VisibleContent>
					<VisibleContent visible={isAliPay}>
						<AliPayContent/>
					</VisibleContent>
					<VisibleContent visible={isUsdtTrc20}>
						<UsdtTrc20 userId={this.props?.user?.id} paymentDetail={paymentDetail}/>
					</VisibleContent>
				</Container>
				<Backdrop open={isBackdrop}>
					<CircularProgress/>
				</Backdrop>
			</Container>
		)
	}
}

export default TopUpBalanceSlugPage
